/**
 * Public model portfolio disclosure (bundled static series on marketing surfaces).
 */

/** Main label beside published performance figures. */
export const MODEL_PORTFOLIO_HEADLINE_DISCLOSURE =
  "Model portfolio formed 1 Oct 2024 and rebalanced 1 Oct 2025.";

/** Standard past-performance line (separate from {@link MODEL_PORTFOLIO_HEADLINE_DISCLOSURE}). */
export const MODEL_PORTFOLIO_PAST_PERFORMANCE_DISCLAIMER =
  "Past performance isn't a guarantee.";

/** Badge and tight headline spaces. */
export const MODEL_PORTFOLIO_BADGE_LABEL = "Model portfolio";

/** Footnote where total-return methodology should be explicit. */
export const MODEL_PORTFOLIO_TOTAL_RETURN_FOOTNOTE =
  "Returns are total return, shown against the S&P 500.";

/** Extended fine print on performance surfaces (total-return methodology). */
export const MODEL_PORTFOLIO_EXTENDED_FOOTNOTE = MODEL_PORTFOLIO_TOTAL_RETURN_FOOTNOTE;

/** Whole-percent sign for public headline copy (ASCII minus). */
export function modelPortfolioWholePercentSign(value: number): string {
  if (value > 0) return "+";
  if (value < 0) return "-";
  return "";
}

/** Whole-percent label for public model-portfolio totals (matches headline rounding). */
export function formatModelPortfolioWholePercent(value: number): string {
  const rounded = Math.round(value);
  return `${modelPortfolioWholePercentSign(rounded)}${Math.abs(rounded)}%`;
}

/** Whole-percent sign for public headline copy (ASCII minus). */
function headlinePercentSign(value: number): string {
  return modelPortfolioWholePercentSign(value);
}

/**
 * First line of the public model-portfolio performance headline.
 * Pass rounded whole-number total returns and the last published week-ending (ISO).
 */
export function modelPortfolioPerformanceHeadlineLine1(
  portfolioWholePercent: number,
  spWholePercent: number,
  throughWeekEndingIso: string,
): string {
  const fmt = (value: number) =>
    `${headlinePercentSign(value)}${Math.abs(value)}%`;
  return `${fmt(portfolioWholePercent)} vs ${fmt(spWholePercent)} S&P 500 (total return, through ${throughWeekEndingIso})`;
}
